import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/CustomerPickupIcon.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/deliverInstallationBanner.jpg");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/DeliveryIcon.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/FAQIcon.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/InstallationIcon.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/rightArrow.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/testimonialIcon.webp");
